// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'
import nl from './nl'
import de from './de'
import bg from './bg'
import hr from './hr'
import cs from './cs'
import hu from './hu'
import it from './it'
import pl from './pl'
import ro from './ro'
import sl from './sl'
import es from './es'
import tr from './tr'
import el from './el'
import pt from './pt'
import lt from './lt'
import lv from './lv'
import et from './et'
import sk from './sk'
import th from './th'
import srb from './srb'

const locales = {
  en: en,
  fr: fr,
  nl: nl,
  de: de,
  bg: bg,
  hr: hr,
  cs: cs,
  hu: hu,
  it: it,
  pl: pl,
  ro: ro,
  sl: sl,
  es: es,
  tr: tr,
  el: el,
  pt: pt,
  lt: lt,
  lv: lv,
  et: et,
  sk: sk,
  th: th,
  srb: srb
}

export default locales
